// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_16t9EgNt5SK5yse9qNCBft_0","box-container":"TE7OMeZEVzI3XSqmbJMY9_0","box":"X3aZ7g89NI4p77F7fOSeV_0"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"id":2,"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6b069ba1","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"strictMath":"on","sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src.player/ui/game-states/LOBBY/index.vue
// module id = 219
// module chunks = 0